import React, { useState, useEffect } from 'react';
import {
  Button,
  Container, Divider, IconButton,
} from '@mui/material';
import {
  ArrowBackRounded, ExpandLessRounded, ExpandMoreRounded,
} from '@mui/icons-material';
import { useNavigate, useParams } from 'react-router-dom';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import Elements from '../../../Elements';
import 'react-medium-image-zoom/dist/styles.css';
import ROUTES from '../../../../Configs/routes';
import Images from '../../../../Configs/images';
import { getUserDigitalBoxDetails } from '../../../../Redux/Models/box';
import { getUserData } from '../../../../Utils/storages';
import { getCategories, getConditions } from '../../../../Redux/Models/master';

export default function StorageInfo({ classes, selectedBox, isLoadingDetails }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userData = getUserData();
  const { storageId } = useParams();
  // const [hideCode, setHideCode] = useState(true);

  useEffect(() => {
    if (!storageId) {
      navigate(ROUTES.myStorages());
    } else {
      dispatch(getUserDigitalBoxDetails(userData.id, storageId));
    }
  }, [storageId]);

  return (
    <Elements.PageBase noNav>
      <div className={classes.root}>
        <Container className="sticky" sx={{ py: 2, bgcolor: '#fff' }}>
          <div className="flex align-items-center">
            <IconButton sx={{ p: 0 }} onClick={() => navigate(-1)}>
              <ArrowBackRounded className="black" />
            </IconButton>
            <h4>Storage info</h4>
          </div>
        </Container>

        <div className="mt-1">
          <Container>

            <div className="content-card">
              <div className="flex space-between">
                <div className="flex-1">
                  <div className="s-12 mute">Storage number</div>
                  <div className="s-14 weight-700 mt-1">
                    Aisle
                    {' '}
                    {selectedBox.column}
                    {selectedBox.row}
                  </div>
                </div>
                <div className="flex-1">
                  <div className="s-12 mute">Total items</div>
                  <div className="s-14 weight-700 mt-2">
                    {selectedBox.items?.length}
                    {' '}
                    Items
                  </div>
                </div>
              </div>
              <div className="flex space-between mt-2">
                <div className="s-12 mute">{selectedBox.id}</div>
                <div className="s-12 mute">{moment(new Date(selectedBox.created_at)).format('HH.mm - DD/MM/YYYY')}</div>
              </div>
              <Divider sx={{ my: 2 }} />
              <div className="flex space-between mt-2">
                <div className="flex-1">
                  <div className="s-12 mute">Category</div>
                  <div className="s-14 weight-500 mt-1">{selectedBox.category_name}</div>
                </div>
                <div className="flex-1">
                  <div className="s-12 mute">Status</div>
                  <div className="flex align-items-center gap-4 mt-1">
                    <img src={Images.VerifiedIcon} alt="verified" />
                    <div className="s-14 weight-500">Verified</div>
                  </div>
                </div>
              </div>
              {/* <div className="mt-3">
                <TextField
                  fullWidth
                  size="small"
                  disabled
                  value={selectedBox.box_code}
                  type={hideCode ? 'password' : 'text'}
                  InputProps={{
                    endAdornment: (
                      <IconButton sx={{ p: 0 }} onClick={() => setHideCode(!hideCode)}>
                        {hideCode
                          ? <VisibilityOff />
                          : <Visibility />}
                      </IconButton>),
                  }}
                />
              </div> */}
            </div>

            <div className="content-card mt-3">
              <div className="weight-700 s-16">Items</div>
              {selectedBox.items?.map((item, index) => (
                <BoxItemData data={item} key={item.id} index={index} isLoading={isLoadingDetails} />
              ))}
            </div>
          </Container>

        </div>
      </div>

    </Elements.PageBase>
  );
}

export function BoxItemData({ index, data, isLoading }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [hide, setHide] = useState(false);
  const [popupReturn, setPopupReturn] = useState(false);

  const { master } = useSelector((state) => state);
  useEffect(() => {
    dispatch(getCategories());
    dispatch(getConditions());
  }, []);
  const toggleHide = () => {
    setHide(!hide);
  };

  const [fields, setField] = useState({
    name: '',
    photo: '',
    description: '',
    volume: 0,
    category_id: '-',
    condition_id: '-',
    notes: '',
  });

  useEffect(() => {
    setField(data);
  }, [data]);

  const renderCategory = () => {
    const selectedCategory = master.categories.filter((cat) => cat.id === fields.category_id);
    if (selectedCategory[0]) {
      return selectedCategory[0].name;
    }

    return '-';
  };

  const renderCondition = () => {
    const selectedCondition = master.conditions.filter((con) => con.id === fields.condition_id);
    if (selectedCondition[0]) {
      return selectedCondition[0].name;
    }

    return '-';
  };

  return (
    <div style={{ borderRadius: 8, border: '1px solid #DADADA', padding: 16 }} className="mt-3">
      <div className="flex space-between align-items-center link" onClick={toggleHide}>
        <h4>
          Item
          {' '}
          {index + 1}
        </h4>
        {hide
          ? <ExpandMoreRounded fontSize="medium" />
          : <ExpandLessRounded fontSize="medium" />}
      </div>
      <div hidden={hide}>
        <Divider sx={{ mt: 2 }} />
        <div className="mt-3">
          <div className="mute mt-2">Item name</div>
          <div className="weight-700 mt-1 s-16">{fields.name}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Item volume</div>
          <div className="weight-700 mt-1 s-16">
            {fields.volume}
            {' '}
            ml
          </div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Category</div>
          <div className="weight-700 mt-1 s-16">{renderCategory(fields.category_id)}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Condition</div>
          <div className="weight-700 mt-1 s-16">{renderCondition(fields.condition_id)}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Notes</div>
          <div className="weight-700 mt-1 s-16">{fields.notes}</div>
        </div>

        <div className="mt-3">
          <div className="mute mt-2">Photo</div>
          <div className="mt-2">
            {' '}
            <img
              width="120"
              height="120"
              alt="profile"
              src={fields.photo}
              className="rounded"
            />
          </div>
        </div>

        <div className="mt-5">
          <Button fullWidth size="large" variant="outlined" className="btn-outlined" onClick={() => setPopupReturn(true)} disabled={isLoading}>
            Request out
          </Button>
        </div>
      </div>

      <Elements.ConfirmationModal
        desc={<div className="center">Request out items from storage?</div>}
        open={popupReturn}
        handleAgree={() => navigate(`${ROUTES.requestReturn()}/${fields.id}`, { state: fields })}
        handleClose={() => setPopupReturn(false)}
      />
    </div>
  );
}
